/**
 * Sovg'a so'rovi — docs/API.md §7.
 *
 * Klient narx yubormaydi (qoida 4): faqat `gift_id` va `combo`.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ME_KEY } from './useMe';
import { WALLET_KEY } from './useWallet';
import { request } from './client';

/**
 * Kontekst ikkita va ular BIR-BIRINI istisno qiladi: `call` uchun
 * `match_id`, `room` uchun `room_id`. Birlashtirilgan tip noto'g'ri
 * juftlikni (masalan `context:'room'` + `match_id`) yozib bo'lmasligini
 * kafolatlaydi — server ham buni rad etadi.
 */
type SendGiftBody = {
  gift_id: number;
  receiver_id: number;
  combo: 1 | 10 | 99;
  client_tx_id: string;
} & ({ context: 'call'; match_id: number } | { context: 'room'; room_id: number });

interface SendGiftResult {
  gift_event_id: number;
  total_gems: number;
  charm_granted: number;
  balance_after: number;
}

export function useSendGift() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (body: SendGiftBody) =>
      request<SendGiftResult>('/gifts/send', { method: 'POST', body }),
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: WALLET_KEY });
      void client.invalidateQueries({ queryKey: ME_KEY });
    },
  });
}
